<template>
  <div>
    <div class="mrB20" />
    <sui-grid
      ref="mainGrid"
      :dataset="'datasetInfo'"
      :columns="defaultGridData0.columns"
      :enabletooltips="true"
      :initialPagesize="5"
      :showDisplayCountControl="false"
    />
  </div>
</template>
<script>
export default {
  name: "PGE_CMT_00004_T01", // eslint-disable-line vue/name-property-casing
  props: {
    pageId: {
      type: String,
      default: ""
    },
    selectedPageId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      localdata: [],
      defaultGridData0: {
        columns: [
          {
            text: this.$t("MSG_TXT_ENTY_NM"),
            datafield: "tableId",
            width: 300
          },
          {
            text: this.$t("MSG_TXT_TRM_PHSC_NM"),
            datafield: "entityName",
            width: 300
          },
          {
            text: this.$t("MSG_TXT_ATRB_NM"),
            datafield: "attributeName"
          },
          
        ]
      }
    };
  },
  datasets: [
    {
      id: "datasetInfo",
      type: "local",
      data: "localdata",
      datafields: [
        { name: "modelName", type: "string", map: "modelName" },
        { name: "entityName", type: "string", map: "entityName" },
        { name: "tableId", type: "string", map: "tableId" },
        { name: "attributeName", type: "string", map: "attributeName" },
        { name: "columnId", type: "string", map: "columnId" }
      ]
    }
  ],
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    getData(termID) {
      if (termID === null) {
        this.datasetInfo.setRawData([]);
      } else if(termID != '') {
        http
          .request("PGE_CMT_00004", "DTS_CMT_00023", {
            path: {
              "term-id": termID
            }
          })
          .then(res => {
            this.datasetInfo.setRawData(res.data);
          })
          .catch(error => {
            console.log(error);
          });
      }
    }
  }
};
</script>
<style scoped>
.line-textarea {
  padding: 0px 8px;
  line-height: 28px;
}
</style>
